import React, {useEffect, useState} from 'react';
import {useDropzone} from 'react-dropzone';
import ControlPointIcon from '@mui/icons-material/ControlPoint';
import "./multielectdropzone.scss";
import HighlightOffRoundedIcon from '@mui/icons-material/HighlightOffRounded';

export type choosedFile = {
    url: string
}

interface IMultiSelectDropzone {
    setSelectedImages: React.Dispatch<React.SetStateAction<choosedFile[]>>
}

export default function MultiSelectDropzone({setSelectedImages}: IMultiSelectDropzone) {
    const [files, setFiles] = useState<choosedFile[]>([]);
    const {getRootProps, getInputProps, isDragActive} = useDropzone({
        accept: {
            'image/*': []
        },
        onDrop: acceptedFiles => {
            setFiles(files.concat(acceptedFiles.map(file => Object.assign(file, {
                url: URL.createObjectURL(file)
            }))));
            setSelectedImages(files.concat(acceptedFiles.map(file => Object.assign(file, {
                url: URL.createObjectURL(file)
            }))));
        }
    });

    const thumbs = files.map((file, index) => (
        <div className="Multi-Select-Drop-Zone-Preview" key={index}>
            <img
                className="img-fluid"
                src={file.url}
                alt={"selected"}
                onLoad={() => {
                    URL.revokeObjectURL(file.url)
                }}
            />
            <div onClick={() => {
                const newFiles = files.filter(item => item.url !== file.url);
                setFiles(newFiles);
                setSelectedImages(newFiles);
            }} className="Multi-Select-Drop-Zone-Remove-Image">
                <HighlightOffRoundedIcon fontSize={"large"}/>
            </div>
        </div>
    ));

    useEffect(() => {
        return () => files.forEach(file => URL.revokeObjectURL(file.url));
    }, []);

    return (
        <div className="Multi-Select-Drop-Zone">
            <div className="Multi-Select-Drop-Zone-Preview-Box">
                <div className="Multi-Select-Drop-Zone-Top align-bottom">
                    <div {...getRootProps({className: 'dropzone Multi-Select-Drop-Zone-Box'})}>
                        <input {...getInputProps()} multiple={true}/>
                        {
                            isDragActive ? <p>عکس را رها کنید</p> : <ControlPointIcon fontSize={"large"}/>
                        }
                    </div>
                </div>
                {thumbs}
            </div>
        </div>
    );
}